import { ReactNode } from "react";
// hooks
import useAuth from "../hooks/useAuth";
// components
import Page403 from "../pages/Page403";

// ----------------------------------------------------------------------

type AdminGuardProps = {
  children: ReactNode;
};

export default function AdminGuard({ children }: AdminGuardProps) {
  const { user } = useAuth();
  const is_superuser = user?.is_superuser;

  if (!is_superuser) {
    return <Page403 />;
  }

  return <>{children}</>;
} 